import { remap } from "common/math";
import { delay, delayAnimation } from "common/promises";
import { ReesizeEventHandler } from "common/resize";
import { getSkip } from "common/skipper";
import { paths } from "from-start/scene/resources";
import { calculateScreen, MAXIMUM_HEIGHT } from "from-start/screen";
import { html, LitElement } from "lit-element";
import { classMap } from "lit-html/directives/class-map";
import { styleMap } from "lit-html/directives/style-map";
import * as R from "ramda";
/**
 * Attribute:
 * progress
 *   - short: [number; 6]
 *   - long: [number]
 * all progres value is 0 ~ 100
 */
export class Progress extends LitElement {
    constructor() {
        super();
        this.fadeOut = false;
        this.resizer = null;
        this.progress = {
            short: [0, 0, 0, 0, 0, 0],
            long: [0],
        };
        this.onResize = this.onResize.bind(this);
    }
    static get properties() {
        return {
            progress: { type: Object },
        };
    }
    makeFadeOut() {
        this.fadeOut = true;
        this.requestUpdate();
    }
    fadeOutAndHide() {
        this.makeFadeOut();
        delay(1000).then(() => {
            $(this).hide();
            this.fadeOut = false;
            this.requestUpdate();
        });
    }
    onResize() {
        this.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizer = new ReesizeEventHandler();
        this.resizer.add(this.onResize);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.resizer != null) {
            this.resizer.drop();
            this.resizer = null;
        }
    }
    createRenderRoot() {
        return this;
    }
    setProgress({ index, progress }) {
        switch (index) {
            case 0:
                this.progress.short[0] = progress;
                break;
            case 1:
                this.progress.short[1] = progress;
                break;
            case 2:
                this.progress.short[2] = progress;
                break;
            case 3:
                this.progress.short[3] = progress;
                break;
            case 4:
                this.progress.short[4] = progress;
                break;
            case 5:
                this.progress.short[5] = progress;
                break;
            case 6:
                this.progress.long[0] = progress;
                break;
            default:
                throw new Error("invalid progress index " + index);
        }
    }
    async run({ index, seconds: secondsOverride, video, }) {
        const video360 = 42;
        const selfie = 79;
        const between12 = 159;
        const between23 = 69;
        const between34 = 110;
        const between45 = 84;
        const between56 = 90;
        const between67 = 207;
        let seconds = [
            video360,
            selfie,
            between12,
            between23,
            between34,
            between45,
            between56,
            between67,
        ][index];
        if (secondsOverride != null) {
            seconds = secondsOverride;
        }
        const startTime = Date.now();
        let endTime = startTime + seconds * 1000;
        if (getSkip().skipDelay) {
            // endTime = startTime + 1000;
            endTime = startTime + (seconds * 1000) / 10;
        }
        for (let i = 0; i < this.progress.short.length; i += 1) {
            this.progress.short[i] = 0;
        }
        for (let i = 0; i < this.progress.long.length; i += 1) {
            this.progress.long[i] = 0;
        }
        for (let i = 0; i < index; i += 1) {
            this.setProgress({ index: i, progress: 100 });
        }
        if (video != null) {
            const startTime = video.currentTime;
            let lastTime = video.currentTime;
            let hasEnded = false;
            const timeupdate = () => {
                const prevLastTime = lastTime;
                const newLastTime = video.currentTime;
                // 끝부분 루프를 걸었을 수 있음.
                if (newLastTime < prevLastTime) {
                    hasEnded = true;
                    return;
                }
                lastTime = newLastTime;
            };
            const ended = () => {
                hasEnded = true;
            };
            video.addEventListener("timeupdate", timeupdate);
            video.addEventListener("ended", ended);
            let stop = video.duration;
            if (secondsOverride != null) {
                stop = secondsOverride;
            }
            while (!hasEnded) {
                const progress = remap({
                    value: lastTime,
                    start1: startTime,
                    stop1: stop,
                    start2: 0,
                    stop2: 100,
                });
                this.setProgress({ index, progress });
                this.requestUpdate();
                await delayAnimation(1000 / 30);
            }
            video.removeEventListener("timeupdate", timeupdate);
            video.removeEventListener("ended", ended);
        }
        else {
            while (Date.now() < endTime) {
                const progress = remap({
                    value: Date.now(),
                    start1: startTime,
                    stop1: endTime,
                    start2: 0,
                    stop2: 100,
                });
                this.setProgress({ index, progress });
                this.requestUpdate();
                await delayAnimation(1000 / 30);
            }
        }
    }
    render() {
        const { viewport } = calculateScreen();
        const top = (MAXIMUM_HEIGHT - viewport.height) / 2;
        const backgroundStyle = {
            left: "277px",
            top: `${top + 15}px`,
        };
        const topStyle = {
            transition: "all 0.5s linear",
        };
        const topClasses = {
            white: true,
            "o-0": this.fadeOut,
        };
        return html `<div
      class="${classMap(topClasses)}"
      style="${styleMap(topStyle)}"
    >
      <img
        class="absolute top-0"
        style="${styleMap(backgroundStyle)}"
        src="${paths.video360TimelineBarBackground}"
      />
      ${R.map((index) => progressImage({
            src: paths.video360TimelineBarLong,
            width: 166,
            height: 30,
            top: top + 27,
            left: 277 + 130 * index,
            progress: this.progress.long[index],
        }), R.range(0, 1))}
      ${R.map((index) => {
            return progressImage({
                src: paths.video360TimelineBarShort,
                width: 26,
                height: 48,
                left: 283 + 26 * index,
                top: top + 18,
                progress: this.progress.short[index],
            });
        }, R.range(0, 6))}
    </div>`;
    }
}
function progressImage({ progress, src, width, height, top, left, }) {
    const wrapperStyle = {
        width: `${width}px`,
        height: `${height}px`,
        top: `${top}px`,
        left: `${left}px`,
    };
    const innerStyle = { width: `${progress}%` };
    return html `<div class="absolute" style="${styleMap(wrapperStyle)}">
    <img
      class="object-fit-cover object-position-left h-100"
      src="${src}"
      style="${styleMap(innerStyle)}"
    />
  </div>`;
}
customElements.define("jh-360-video-progress", Progress);
//# sourceMappingURL=progress.js.map